import { api } from "./client";

const BASE = "/games/mlb-ps";

export async function getPsActiveSeason() {
  const resp = await api.get(`${BASE}/seasons/active`);
  return resp.data;
}

export async function getMyPsPools(seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/mine`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getAllPsPools(seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function createPsPool(seasonId, { name, pool_depth }) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/`, { name, pool_depth });
  return resp.data;
}

export async function joinPsPool(seasonId, poolId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/join`);
  return resp.data;
}

export async function getPsPool(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}`);
  return resp.data;
}

export async function updatePsPool(seasonId, poolId, body) {
  const resp = await api.patch(`${BASE}/seasons/${seasonId}/pools/${poolId}`, body);
  return resp.data;
}

export async function togglePsMemberPaid(seasonId, poolId, userId, paid) {
  const resp = await api.patch(`${BASE}/seasons/${seasonId}/pools/${poolId}/members/${userId}/paid`, { paid });
  return resp.data;
}

export async function togglePsCoAdmin(seasonId, poolId, userId, isCoAdmin) {
  const resp = await api.patch(`${BASE}/seasons/${seasonId}/pools/${poolId}/members/${userId}/co-admin`, { is_co_admin: isCoAdmin });
  return resp.data;
}

export async function removePsMember(seasonId, poolId, userId) {
  const resp = await api.delete(`${BASE}/seasons/${seasonId}/pools/${poolId}/members/${userId}`);
  return resp.data;
}

export async function getPsPayouts(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/payouts/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function savePsPayouts(seasonId, poolId, payouts) {
  const resp = await api.put(`${BASE}/seasons/${seasonId}/pools/${poolId}/payouts/`, { payouts });
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function sendPsInvites(seasonId, poolId, emails, message, subject, mode) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/invite`, { emails, message, subject, mode }, { timeout: 120000 });
  return resp.data;
}

export async function getPsEligiblePlayers(seasonId, search) {
  const params = search ? { search } : {};
  const resp = await api.get(`${BASE}/seasons/${seasonId}/players/`, { params });
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getPsAllPlayers(seasonId, search) {
  const params = search ? { search } : {};
  const resp = await api.get(`${BASE}/seasons/${seasonId}/players/all`, { params });
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getMyPsEntries(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/entries/mine`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getAllPsEntries(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/entries/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function createPsEntry(seasonId, poolId, { team_name, player_ids }) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/entries/`, {
    team_name,
    player_ids,
  });
  return resp.data;
}

export async function editPsEntry(seasonId, poolId, entryId, { team_name, player_ids }) {
  const resp = await api.put(`${BASE}/seasons/${seasonId}/pools/${poolId}/entries/${entryId}`, {
    team_name,
    player_ids,
  });
  return resp.data;
}

export async function deletePsEntry(seasonId, poolId, entryId) {
  await api.delete(`${BASE}/seasons/${seasonId}/pools/${poolId}/entries/${entryId}`);
}

export async function sendPsRecap(seasonId, poolId, toEmail) {
  const params = toEmail ? { to_email: toEmail } : {};
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/recap`, null, { params });
  return resp.data;
}

export async function getPsLeaderboard(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/leaderboard/`);
  return resp.data;
}

// ── Smack Board ───────────────────────────────────────────────────────────────

export async function getPsSmackMessages(poolId, seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/`);
  return resp.data;
}

export async function postPsSmackMessage(poolId, body, seasonId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/`, { body });
  return resp.data;
}

export async function getPsSmackReplies(poolId, messageId, seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/replies`);
  return resp.data;
}

export async function postPsSmackReply(poolId, messageId, body, seasonId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/replies`, { body });
  return resp.data;
}

export async function reactPsSmack(poolId, messageId, reaction, seasonId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/react`, { reaction });
  return resp.data;
}

export async function deletePsSmackMessage(poolId, messageId, seasonId) {
  const resp = await api.delete(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}`);
  return resp.data;
}

export async function getPsScoreboard(seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/scoreboard`);
  return resp.data;
}
